<div class="col-md-12" style="display: flex; justify-content: flex-start; align-items: flex-start;">
    <div class="col-md-11 body-class">
      <h1>Gestion TVA</h1>
    </div>
    <div class="col-md-1 body-class" style="padding-top: 15px;">
      <button class="pull-right" color="warn" mat-raised-button type="button" (click)="onLeave()">
        <mat-icon>cancel</mat-icon> Fermer
      </button>
    </div>
  </div>
  <div class="col-md-12" style="display: flex; justify-content: flex-start; align-items: flex-start;">
    <div class="col-md-8">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Rechercher une TVA</mat-label>
        <input matInput [(ngModel)]="objet.query" (change)="search()" (keydown.enter)="search()" placeholder="Code, libelle de la TVA">
      </mat-form-field>
    </div>
    <div class="col-md-1 top">
      <button type="button" mat-raised-button color="primary" (click)="onCreate()" mat-icon-button><mat-icon>add</mat-icon></button>
    </div>
    <div class="col-md-1 top">
      <button mat-raised-button color="primary" type="button" (click)="search()" style="color: white;"mat-icon-button><mat-icon>search</mat-icon></button>
    </div>
  </div>  
  <div class="col-md-12">
    <div class="mat-table">
      <div class="table_principale">
        <table mat-table matSort [dataSource]="matDataSource" multiTemplateDataRows class="mat-elevation-z8" (matSortChange)="sortData($event)" matSortActive="code">
          <caption>Liste des tvas</caption>
          <ng-container matColumnDef="code">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Code </th>
            <td mat-cell *matCellDef="let element" (click)="onModify(element)"> {{element.code}} </td>
          </ng-container>
      
          <ng-container matColumnDef="libelle">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Libellé </th>
            <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.libelle}}</div> </td>
          </ng-container>
  
          <ng-container matColumnDef="taux">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Taux </th>
            <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.taux}} %</div> </td>
          </ng-container>

          <ng-container matColumnDef="autoIntra">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Auto-liquidation </th>
            <td mat-cell *matCellDef="let element" (click)="onModify(element)"> 
              <div class="left" *ngIf="element.autoIntra">Oui</div> 
              <div class="left" *ngIf="!element.autoIntra">Non</div> 
            </td>
          </ng-container>

          <ng-container matColumnDef="compteOd1">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Compte OD 1</th>
            <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.compteOd1}}</div> </td>
          </ng-container>

          <ng-container matColumnDef="compteOd2">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Compte OD 2 </th>
            <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.compteOd2}}</div> </td>
          </ng-container>

          <ng-container matColumnDef="compteFact1">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Compte fact 1 </th>
            <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.compteFact1}}</div> </td>
          </ng-container>

          <ng-container matColumnDef="compteFact2">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Compte fact 2 </th>
            <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.compteFact2}}</div> </td>
          </ng-container>

          <ng-container matColumnDef="compteCompta">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Compte compta 1 </th>
            <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.compteCompta}}</div> </td>
          </ng-container>

          <ng-container matColumnDef="compteCompta2">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Compte compta 2 </th>
            <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.compteCompta2}}</div> </td>
          </ng-container>
      
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element" style="padding: 0;">
              <div class="center">
                <span *ngIf="element.agenceId !== null" (click)="onDelete(element)">
                  <mat-icon class="red-icon">close</mat-icon>
                </span>
              </div>
            </td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns, sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"></tr>
        </table>
      
        <div class="footer">
          <mat-paginator
            #paginator
            [length]="length"
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 25, 50]"
            (page)="changePage($event)">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
  